import { useEffect, useRef, useState } from 'react';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow, faPlug } from '@fortawesome/free-solid-svg-icons';
import { useToggle } from '../../services/General/useToggle';
import { StopTravelBody } from './StopTravelBody';
import { useConnection } from '../../services/Ros/Connection';
import { ConnectionMessage } from '../../core/Messages/ConnectionMessage';
import { useDrivingMethod, DrivingTypes } from '../../services/Ros/Driving/DrivingProvider';
import { IStopInfo } from './StopTravelBody';
import { Subscriber } from '../../services/Ros/Subscriber';
import { GPS_TOPIC, STATE } from '../../constants/topics';
import '../../css/StreamSelector.css';  // Import the CSS file
import '../../css/path-planning.css'; 
import { useObserver } from '../../utilities/http/routing/ObserverContext';
import { useMaintenanceMode } from '../../utilities/http/routing/MaintenanceContext';
import { ServiceCaller } from '../../services/Ros/ServiceCaller';


interface StopTravelOverlayProps {
    isManualModeActive: boolean;
}


export const StopTravelOverlay = ({ isManualModeActive }: StopTravelOverlayProps)=> {
    const [show, setShow] = useToggle(false);
    const { control, setDisabled } = useDrivingMethod();
    const drivingMethod = useRef<DrivingTypes>(control);
    const connection = useConnection();
    const { isObserver } = useObserver();
    const { maintenanceModeEnabled} = useMaintenanceMode();

    const [initialActiveIndex, setInitialActiveIndex] = useState<string>('');
    const [initialMissionInfo, setInitialMissionInfo] = useState<IStopInfo>({ stops: [] });
    const [initialLaunched, setInitialLaunched] = useState<boolean>(false);

    useEffect(() => {
        if (show) {
            drivingMethod.current = control;
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [show]);

    // useEffect(() => {
    //     console.log(initialActiveIndex)
    // }, [initialActiveIndex]);

    const render = () => {
        if (!connection) {
            return <ConnectionMessage icon={faPlug} text='Robot Not Connected' colour='dark' />;
        } else {
            return (
                <Subscriber name={STATE.name} type={STATE.type} rate={STATE.throttle}>
                    <ServiceCaller name="/state_request_service" type="std_srvs/srv/Trigger">         
                        <StopTravelBody 
                            initialActiveIndex={initialActiveIndex}
                            initialMissionInfo={initialMissionInfo}
                            initialLaunched={initialLaunched}
                            setInitialActiveIndex={setInitialActiveIndex}
                            setInitialMissionInfo={setInitialMissionInfo}
                            setInitialLaunched={setInitialLaunched}
                        />
                    </ServiceCaller>
                </Subscriber>
            );
        }
    }

    return (
        <>
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Stop Traveler</Tooltip>}>
                <Button
                    variant='info'
                    size="lg"
                    onClick={setShow}
                    className={show ? "selected" : ""}
                    disabled={isManualModeActive || isObserver || maintenanceModeEnabled}
                >
                    <FontAwesomeIcon icon={faLocationArrow} inverse={true} size="lg" />
                </Button>
            </OverlayTrigger>
            <Modal 
                fullscreen='lg-down' 
                className='path-planning-modal' 
                dialogClassName='modal-90w overflow-hidden' 
                size='xl' 
                centered 
                show={show} 
                onHide={setShow} >
                <Modal.Header closeButton>
                    <Modal.Title className='text-dark'></Modal.Title>
                </Modal.Header>
                <Modal.Body className='ps-0 pb-0 pt-0'>
                    <Subscriber name={GPS_TOPIC.name} type={GPS_TOPIC.type} rate={GPS_TOPIC.throttle}>
                        {render()}
                    </Subscriber>
                </Modal.Body>
            </Modal>
        </>
    );
}
